/* TNW - Swatch picker behaviour.
   Catalogue comes from /collections/all?view=swatch-data (metafield driven).
   Nothing here infers colour, weight or size from a product title. */
(function () {
  var root = document.querySelector('[data-tnw-swatch]');
  if (!root || root.dataset.booted) return;
  root.dataset.booted = '1';

  var MAX = 0;
  var PRICE = (parseInt(root.dataset.unit, 10) || 0) / 100;

  /* ONE tab per hide, by precedence. finish_texture is multi-value - a
     metallic hide is usually pebbled too - so membership rules would put the
     same hide in several tabs. Printed outranks Metallic because the star and
     camo hides are foil prints, and outranks Nubuck or Tan Leopard files
     under Cow Suede. */
  var TABS = [
    { key:'specialty',  label:'Specialty',     test:function(p){ return has(p.fin,'Printed') || has(p.fin,'Perforated'); } },
    { key:'embossed',   label:'Embossed',      test:function(p){ return has(p.fin,'Embossed'); } },
    { key:'metallic',   label:'Metallic',      test:function(p){ return has(p.fin,'Metallic'); } },
    { key:'suede',      label:'Cow Suede',     test:function(p){ return has(p.fin,'Suede') || has(p.fin,'Nubuck'); } },
    { key:'vegtan',     label:'Veg Tan',       test:function(p){ return has(p.tan,'Vegetable-tanned'); } },
    { key:'distressed', label:'Distressed',    test:function(p){ return has(p.fin,'Pull-Up / Distressed'); } },
    { key:'lambskin',   label:'Lambskin',      test:function(p){ return has(p.lt,'Lambskin'); } },
    { key:'natural',    label:'Natural Grain', test:function(p){ return has(p.fin,'Natural Grain / Pebbled') || has(p.fin,'Smooth'); } }
  ];

  /* Cross-cutting: a whole hide keeps its finish tab AND appears here. */
  var CROSS = [
    { key:'whole', label:'Whole Hides', test:function(p){ return has(p.fmt,'Whole Hide'); } }
  ];

  var COLOR_MAP = {
    black:['Black'], brown:['Brown','Tan / Beige'], natural:['White / Cream'],
    red:['Red / Burgundy'], blue:['Blue'], green:['Green'], grey:['Grey'],
    metallic:['Metallic'], purple:['Pink / Purple'], orange:['Yellow / Orange'],
    multi:['Multicolor']
  };
  var WEIGHT_MAP = { light:['Lightweight'], standard:['Medium'], heavy:['Heavy','Extra Heavy'] };

  function has(a, v) { if (!a) return false; return Array.isArray(a) ? a.indexOf(v) !== -1 : a === v; }
  function hasAny(a, w) { for (var i = 0; i < w.length; i++) if (has(a, w[i])) return true; return false; }
  function norm(x) { return (x || '').toLowerCase().replace(/[^a-z0-9]+/g, ''); }
  function tabOf(p) { for (var i = 0; i < TABS.length; i++) if (TABS[i].test(p)) return TABS[i]; return null; }
  function specOf(p) { return (p.oz && p.mm) ? (p.oz + '  ·  ' + p.mm) : (p.oz || p.mm || ''); }
  function money(n) { return '$' + n.toFixed(2).replace(/\.00$/, ''); }

  var all = [], selected = [], rank = {}, justAdded = null, activeCol = null;
  var searchVal = '', colorFilter = '', sizeFilter = '', thicknessFilter = '';

  var tabsEl   = document.getElementById('tnw-sc-tabs');
  var tabsWrap = document.getElementById('tnw-tabs-wrap');
  var gridEl   = document.getElementById('tnw-sc-grid');
  var labelEl  = document.getElementById('tnw-sc-label');
  var noteEl   = document.getElementById('tnw-sc-note');
  var searchEl = document.getElementById('tnw-search');
  var colorSel = document.getElementById('tnw-color-filter');
  var sizeSel  = document.getElementById('tnw-size-filter');
  var thickSel = document.getElementById('tnw-thickness-filter');
  var arrowL   = document.getElementById('tnw-arrow-left');
  var arrowR   = document.getElementById('tnw-arrow-right');
  var cBar     = document.getElementById('tnw-counter-bar');
  var prevEl   = document.getElementById('tnw-sc-preview');
  var prevRow  = document.getElementById('tnw-sc-preview-row');
  var prevSub  = document.getElementById('tnw-sc-preview-sub');

  window.addEventListener('scroll', function () {
    if (cBar) cBar.classList.toggle('lifted', cBar.getBoundingClientRect().top <= 2);
  }, { passive:true });

  showSkeletons(8);

  /* No sort_by on the data pass - best-selling order is recalculated between
     requests, which duplicated one product and skipped another. Ordering is
     fetched separately, where a hiccup only costs position. */
  function pageUrl(n)  { return '/collections/all?view=swatch-data&page=' + n; }
  function orderUrl(n) { return '/collections/all?view=swatch-order&sort_by=best-selling&page=' + n; }

  function loadOrder() {
    return fetch(orderUrl(1)).then(function (r) { return r.json(); }).then(function (first) {
      var seq = (first.ids || []).slice(), rest = [];
      for (var p = 2; p <= (first.pages || 1); p++) rest.push(fetch(orderUrl(p)).then(function (r) { return r.json(); }));
      return Promise.all(rest).then(function (pages) {
        (pages || []).forEach(function (pg) { seq = seq.concat(pg.ids || []); });
        seq.forEach(function (id, i) { var k = String(id); if (rank[k] === undefined) rank[k] = i; });
      });
    }).catch(function () {});
  }

  fetch(pageUrl(1)).then(function (r) { return r.json(); }).then(function (first) {
    all = first.items || [];
    var rest = [loadOrder()];
    for (var p = 2; p <= (first.pages || 1); p++) rest.push(fetch(pageUrl(p)).then(function (r) { return r.json(); }));
    return Promise.all(rest);
  }).then(function (pages) {
    (pages || []).forEach(function (p) { if (p && p.items) all = all.concat(p.items); });

    var seen = {}, unique = [];
    all.forEach(function (p) {
      var id = String(p.id);
      if (seen[id]) return;
      seen[id] = true;
      p.id = id;
      p.tab = tabOf(p);
      p.spec = specOf(p);
      p.searchTitle = (p.t + ' ' + (p.col||[]).join(' ') + ' ' + (p.fin||[]).join(' ') + ' ' + (p.bf||[]).join(' ') + ' ' + (p.oz||'')).toLowerCase();
      unique.push(p);
    });
    all = unique;

    all.sort(function (a, b) {
      var ra = rank[a.id], rb = rank[b.id];
      if (ra === undefined) ra = Infinity;
      if (rb === undefined) rb = Infinity;
      return ra - rb;
    });

    buildTabs(); preselect(); renderGrid(); interceptATC(); setupArrows();
  }).catch(function () {
    gridEl.innerHTML = '<span class="tnw-sw-empty">Failed to load - please refresh.</span>';
  });

  function showSkeletons(n) {
    gridEl.innerHTML = '';
    for (var i = 0; i < n; i++) { var sk = document.createElement('div'); sk.className = 'tnw-sw-sk'; gridEl.appendChild(sk); }
  }

  function getFiltered() {
    var pool;
    if (activeCol === 'all' || !activeCol) pool = all;
    else {
      var cross = null;
      for (var i = 0; i < CROSS.length; i++) if (CROSS[i].key === activeCol) cross = CROSS[i];
      pool = cross ? all.filter(function (p) { return cross.test(p); })
                   : all.filter(function (p) { return p.tab && p.tab.key === activeCol; });
    }
    return pool.filter(function (p) {
      if (searchVal && p.searchTitle.indexOf(searchVal) === -1) return false;
      if (colorFilter && !hasAny(p.col, COLOR_MAP[colorFilter] || [])) return false;
      if (sizeFilter && p.sb !== sizeFilter) return false;
      if (thicknessFilter && !hasAny([p.wb], WEIGHT_MAP[thicknessFilter] || [])) return false;
      return true;
    });
  }

  function findProduct(id) { for (var i = 0; i < all.length; i++) if (all[i].id === id) return all[i]; return null; }

  function moveIndicator(btn) {
    if (!btn || !tabsWrap) return;
    var wr = tabsWrap.getBoundingClientRect(), br = btn.getBoundingClientRect();
    tabsWrap.style.setProperty('--ind-left', (br.left - wr.left) + 'px');
    tabsWrap.style.setProperty('--ind-width', br.width + 'px');
  }

  function buildTabs() {
    tabsEl.innerHTML = '';
    var allBtn = document.createElement('button');
    allBtn.className = 'tnw-sw-tab'; allBtn.dataset.c = 'all'; allBtn.textContent = 'All';
    tabsEl.appendChild(allBtn);

    /* Tab order follows sales. all is already best-selling sorted, so a tab
       sits where its best seller sits. Whole Hides ranks with everything else
       rather than being pinned to the end. */
    var cands = [];
    TABS.forEach(function (t) {
      for (var k = 0; k < all.length; k++) if (all[k].tab && all[k].tab.key === t.key) { cands.push({ t:t, rank:k }); return; }
    });
    CROSS.forEach(function (t) {
      for (var k = 0; k < all.length; k++) if (t.test(all[k])) { cands.push({ t:t, rank:k }); return; }
    });
    cands.sort(function (a, b) { return a.rank - b.rank; });

    if (!activeCol && cands.length) activeCol = cands[0].t.key;

    cands.forEach(function (c) {
      var btn = document.createElement('button');
      btn.className = 'tnw-sw-tab' + (c.t.key === activeCol ? ' active' : '');
      btn.dataset.c = c.t.key; btn.textContent = c.t.label;
      tabsEl.appendChild(btn);
    });

    setTimeout(function () { moveIndicator(tabsEl.querySelector('.active')); }, 80);

    tabsEl.addEventListener('click', function (e) {
      var btn = e.target.closest('.tnw-sw-tab'); if (!btn) return;
      tabsEl.querySelectorAll('.tnw-sw-tab').forEach(function (b) { b.classList.remove('active'); });
      btn.classList.add('active'); activeCol = btn.dataset.c;
      btn.scrollIntoView({ behavior:'smooth', block:'nearest', inline:'center' });
      setTimeout(function () { moveIndicator(btn); }, 300);
      searchEl.value = ''; searchVal = '';
      colorSel.value = ''; colorFilter = '';
      sizeSel.value  = ''; sizeFilter  = '';
      thickSel.value = ''; thicknessFilter = '';
      renderGrid();
    });
  }

  function setupArrows() {
    arrowL.addEventListener('click', function () { tabsEl.scrollBy({ left:-140, behavior:'smooth' }); setTimeout(function(){ moveIndicator(tabsEl.querySelector('.active')); }, 300); });
    arrowR.addEventListener('click', function () { tabsEl.scrollBy({ left:140, behavior:'smooth' }); setTimeout(function(){ moveIndicator(tabsEl.querySelector('.active')); }, 300); });
    tabsEl.addEventListener('scroll', function () { updateArrows(); moveIndicator(tabsEl.querySelector('.active')); });
    window.addEventListener('resize', function () { moveIndicator(tabsEl.querySelector('.active')); });
    updateArrows();
  }
  function updateArrows() {
    arrowL.disabled = tabsEl.scrollLeft <= 4;
    arrowR.disabled = tabsEl.scrollLeft + tabsEl.clientWidth >= tabsEl.scrollWidth - 4;
  }

  var searchTimer;
  searchEl.addEventListener('input', function () {
    clearTimeout(searchTimer);
    searchTimer = setTimeout(function () {
      searchVal = searchEl.value.trim().toLowerCase();
      if (searchVal) {
        tabsEl.querySelectorAll('.tnw-sw-tab').forEach(function (b) { b.classList.remove('active'); });
        var t = tabsEl.querySelector('[data-c="all"]');
        if (t) { t.classList.add('active'); moveIndicator(t); }
        activeCol = 'all';
      }
      renderGrid();
    }, 200);
  });

  colorSel.addEventListener('change', function () { colorFilter = colorSel.value; renderGrid(); });
  sizeSel.addEventListener('change',  function () { sizeFilter  = sizeSel.value;  renderGrid(); });
  thickSel.addEventListener('change', function () { thicknessFilter = thickSel.value; renderGrid(); });

  /* Deep link. A PDP links here with ?fam= and ?swatch=. Pre-cuts are not
     swatchable, so the link resolves to the parent hide: family first, then
     the title up to the first en dash, which a hide shares with its pre-cut
     siblings. */
  function preselect() {
    var qs = window.location.search;
    if (!qs) return;
    var params = {};
    qs.replace(/^\?/, '').split('&').forEach(function (kv) {
      var i = kv.indexOf('=');
      if (i > 0) params[decodeURIComponent(kv.slice(0, i))] = decodeURIComponent(kv.slice(i + 1).replace(/\+/g, ' '));
    });
    var fam = params.fam, key = params.swatch, handle = params.h;
    if (!fam && !key && !handle) return;

    var hit = null, i;
    if (handle) for (i = 0; i < all.length; i++) if (all[i].h === handle) { hit = all[i]; break; }
    if (!hit && fam) for (i = 0; i < all.length; i++) if (all[i].fam && norm(all[i].fam) === norm(fam)) { hit = all[i]; break; }
    if (!hit && key) {
      var k = norm(key);
      for (i = 0; i < all.length; i++) if (norm(all[i].key) === k) { hit = all[i]; break; }
      if (!hit) for (i = 0; i < all.length; i++) if (norm(all[i].t).indexOf(k) === 0) { hit = all[i]; break; }
    }
    if (!hit) return;

    selected.push(hit.id);
    if (hit.tab) {
      activeCol = hit.tab.key;
      var btn = tabsEl.querySelector('[data-c="' + activeCol + '"]');
      if (btn) {
        tabsEl.querySelectorAll('.tnw-sw-tab').forEach(function (b) { b.classList.remove('active'); });
        btn.classList.add('active');
        setTimeout(function () { moveIndicator(btn); btn.scrollIntoView({ behavior:'smooth', block:'nearest', inline:'center' }); }, 120);
      }
    }
    justAdded = hit.id;
    updateUI();
  }

  /* Card preview - filled tiles, then empty slots, so it reads as a card
     being built rather than a list. */
  function renderPreview() {
    if (!prevEl) return;
    if (!selected.length) { prevEl.style.display = 'none'; return; }
    prevEl.style.display = '';
    prevSub.textContent = selected.length + (selected.length === 1 ? ' leather' : ' leathers');
    prevRow.innerHTML = '';

    selected.forEach(function (id) {
      var p = findProduct(id); if (!p) return;
      var slot = document.createElement('div');
      slot.className = 'tnw-sw-slot';
      slot.title = p.t + (p.oz ? ' - ' + p.oz : '');
      if (p.img) { var im = document.createElement('img'); im.src = p.img; im.alt = p.t; slot.appendChild(im); }
      else { slot.className += ' tnw-sw-slot--empty'; }
      var x = document.createElement('button');
      x.type = 'button'; x.className = 'tnw-sw-slot-x';
      x.setAttribute('aria-label', 'Remove ' + p.t);
      x.innerHTML = '<svg viewBox="0 0 8 8"><line x1="1" y1="1" x2="7" y2="7"/><line x1="7" y1="1" x2="1" y2="7"/></svg>';
      x.addEventListener('click', function () { removeById(id); });
      slot.appendChild(x);
      prevRow.appendChild(slot);
    });

    for (var b = 0; b < 3; b++) {
      var e = document.createElement('div');
      e.className = 'tnw-sw-slot tnw-sw-slot--empty';
      prevRow.appendChild(e);
    }
  }

  function renderGrid() {
    var filtered = getFiltered();
    gridEl.innerHTML = '';
    if (!filtered.length) {
      gridEl.innerHTML = '<span class="tnw-sw-empty">No leathers match - try a different filter.</span>';
      return;
    }
    filtered.forEach(function (p) {
      var isSel = selected.indexOf(p.id) !== -1;
      var isDim = !isSel && MAX > 0 && selected.length >= MAX;

      var card = document.createElement('div');
      card.className = 'tnw-sw-card' + (isSel ? ' selected' : '') + (isDim ? ' disabled' : '');

      if (p.img) {
        var img = document.createElement('img');
        img.className = 'tnw-sw-card-img'; img.src = p.img; img.alt = p.t; img.loading = 'lazy';
        card.appendChild(img);
      } else {
        var ph = document.createElement('div');
        ph.className = 'tnw-sw-card-img'; ph.style.background = '#d4c4a8';
        card.appendChild(ph);
      }

      var body = document.createElement('div'); body.className = 'tnw-sw-card-body';
      var coll = document.createElement('span'); coll.className = 'tnw-sw-card-coll';
      coll.textContent = p.tab ? p.tab.label : '';
      var name = document.createElement('div'); name.className = 'tnw-sw-card-name';
      name.textContent = p.t;
      body.appendChild(coll); body.appendChild(name);
      if (p.spec) {
        var spec = document.createElement('span'); spec.className = 'tnw-sw-card-spec';
        spec.textContent = p.spec; body.appendChild(spec);
      }
      card.appendChild(body);

      var chk = document.createElement('div'); chk.className = 'tnw-sw-check';
      chk.innerHTML = '<svg viewBox="0 0 8 8"><polyline points="1,4 3,6 7,2"/></svg>';
      card.appendChild(chk);

      if (justAdded === p.id) {
        card.classList.add('just-added');
        setTimeout(function () { card.scrollIntoView({ behavior:'smooth', block:'center' }); }, 200);
        justAdded = null;
      }

      card.addEventListener('click', function () { toggle(p); });
      gridEl.appendChild(card);
    });
  }

  function toggle(p) {
    var i = selected.indexOf(p.id);
    if (i !== -1) selected.splice(i, 1);
    else { if (MAX > 0 && selected.length >= MAX) return; selected.push(p.id); }
    updateUI(); renderGrid();
  }
  function removeById(id) {
    var i = selected.indexOf(id); if (i !== -1) selected.splice(i, 1);
    updateUI(); renderGrid();
  }

  function updateUI() {
    renderPreview();
    var count = selected.length;
    labelEl.textContent = ' — ' + count + ' selected';
    if (count === 0) {
      noteEl.className = 'tnw-sw-note muted';
      noteEl.textContent = 'Select your leathers — ' + money(PRICE) + ' each.';
    } else {
      noteEl.className = 'tnw-sw-note';
      noteEl.innerHTML = '<span class="tnw-sw-total">' + money(count * PRICE) + '</span> for ' + count +
        ' swatch' + (count > 1 ? 'es' : '') + ' (' + money(PRICE) + ' each) — add to cart above.';
    }
    var atc = document.querySelector('[data-js-product-add-to-cart], button[name="add"]');
    if (atc) {
      atc.disabled = count === 0;
      if (count === 0) atc.classList.add('disabled'); else atc.classList.remove('disabled');
    }
  }

  function interceptATC() {
    var form = document.querySelector('form[action*="/cart/add"], form[data-type="add-to-cart-form"]');
    if (!form) return;
    form.addEventListener('submit', function (e) {
      e.preventDefault(); e.stopImmediatePropagation();
      if (!selected.length) return;
      var variantInput = form.querySelector('input[name="id"]'); if (!variantInput) return;

      /* Weight goes on the cart line: two veg tan sides share a title up to
         the weight, so a title-only property is not cuttable. */
      var properties = {};
      selected.forEach(function (id, i) {
        var p = findProduct(id); if (!p) return;
        properties['Swatch ' + (i + 1)] = p.oz ? (p.t + ' (' + p.oz + ')') : p.t;
      });

      var btn = form.querySelector('[data-js-product-add-to-cart], button[name="add"]');
      if (btn) { btn.disabled = true; var t = btn.querySelector('.button__text'); if (t) t.textContent = 'Adding…'; }

      fetch('/cart/add.js', {
        method:'POST', headers:{ 'Content-Type':'application/json' },
        body: JSON.stringify({ id: parseInt(variantInput.value), quantity: selected.length, properties: properties })
      }).then(function (r) { if (!r.ok) throw new Error(); return r.json(); })
        .then(function () { window.location.href = '/cart'; })
        .catch(function () {
          if (btn) { btn.disabled = false; var t2 = btn.querySelector('.button__text'); if (t2) t2.textContent = 'Add to cart'; }
          alert('Something went wrong. Please try again.');
        });
    }, true);
  }
})();
